export const threeDModelErrorType = {
    "GLOBAL": "Глобальная",
    "SYSTEM": "Системная",
    "MODEL": "Ошибка модели",
    "MATERIAL": "Ошибка материала",
}